
const _ = require('lodash');
import { browserTypes } from 'browser-type-detector';

module.exports = class CalculatorFeedbackFormDictionaries {
	constructor () {
		_.extend(this, {
			Categories: [],
			MaxAttachmentsSize: 5 * 1024 * 1024,
			Regions: [],
			browserTypes: {
				[browserTypes.chrome]: 'Chrome',
				[browserTypes.firefox]: 'Firefox',
				[browserTypes.opera]: 'Opera',
				[browserTypes.ie10or11]: 'IE 10 и выше',
				[browserTypes.ie9]: 'Internet Explorer 9',
				[browserTypes.ie8]: 'Internet Explorer 8',
				[browserTypes.safari]: 'Safari',
				[browserTypes.android]: 'Android',
				[browserTypes.other]: 'Другой',
			},
		});
	}

	loadData (data) {
		_.extend(this, data);
	}
};
